/*
 *  Art Wallet FAQs
 *    Scripts to create a basic accordion for the art wallet FAQ section.
 * 
 *  Version:
 *    1.0.0 - 2021/09/15
 */

import $ from 'jquery';
import { Accordion } from '../../objects/content/Accordion';
var SELECTOR_CONTAINER = '[data-wallet-faqs]';
$(function () {
  return $(SELECTOR_CONTAINER).each(function (i, e) {
    return new Accordion($(e));
  });
});